function isTemporaryIdReduxUtil (id) {
  return id < 0
}

export default isTemporaryIdReduxUtil
